import { cx } from '@emotion/css';
import { CancelledIcon, CheckCircleIcon, Colors, Sizes } from '@snapchat/snap-design-system-icons';
import type { FC } from 'react';

import { p2Css } from '../../../../../../snap-design-system-marketing/src';
import { tagCss, unsupportedTagCss } from './LensStudioPlatformTag.styles';
import type { LensStudioPlatform } from './types';

export const LensStudioPlatformTag: FC<LensStudioPlatform> = ({ name, isSupported }) => {
  return (
    <div className={cx(tagCss, { [unsupportedTagCss]: !isSupported })}>
      <>
        {isSupported ? (
          <CheckCircleIcon size={Sizes.Large} fill={Colors.Green.V200} />
        ) : (
          <CancelledIcon size={Sizes.Large} fill={Colors.Gray.V100} />
        )}
        <span className={p2Css}>{name}</span>
      </>
    </div>
  );
};
